/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { isElement, keys, reduce, orderBy, forEach, findIndex, indexOf, reverse } from 'lodash';

import { store } from '../2-utilities/store';
import { publish, subscribe } from '../2-utilities/event';

import {
    YEAR_SELECTED as yearSelected,
    STOP_MARKERS_POPUP as stopMarkersPopup,
    MARKERS_PLACED as markersPlaced,
    ROW_HOVER as rowHover,
    ROW_CLICKED as rowClicked,
    SIDEBAR_CLOSED,
    ROW_OUT as rowOut
} from '../3-data/consts/eventNames';

import interpolateColors from '../4-features/interpolateColors';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'list',
    baseSelector = `.js-${moduleName}`,
    baseClassName = `c-${moduleName}`,
    classNames = {
        base: baseClassName,
        position: `${baseClassName}__position`,
        name: `${baseClassName}__name`,
        city: `${baseClassName}__city`,
        status: `${baseClassName}__status`,
        score: `${baseClassName}__score`
    },
    { ranking } = store;

let years = keys(ranking),
    year = years[years.length - 1];

/* ========================================================================== *\
    Templating
/* ========================================================================== */
function getStatus(status) {
    let className = classNames.status,
        element = '<span></span>';

    if (status === 'L') {
        className = `${classNames.status} ${classNames.status}--lower`;
    }

    if (status === 'H') {
        className = `${classNames.status} ${classNames.status}--higher`;
    }

    if (status === 'Z') {
        className = `${classNames.status} ${classNames.status}--same`;
    }

    if (status.toLowerCase() === 'nb') {
        element = 'NB';
    }

    return `
        <div class="${className}">
            ${element}
        </div>
    `;
}

function renderAstrix(ranking) {
    if (ranking === 0) {
        return '*';
    }

    return '';
}

function getRanking(ranking, list, color) {
    let className = classNames.position;

    // if (ranking <= 10) {
    //     className = `${classNames.position} ${classNames.position}--top`;
    // }

    // if (ranking > (list.length - 10)) {
    //     className = `${classNames.position} ${classNames.position}--bottom`;
    // }

    if (ranking === 0) {
        return `<div class="${className}"></div>`;
    }

    return `<div class="${className}">
        <div class="${classNames.position}-inner" style="background-color: rgb(${color[0]}, ${color[1]}, ${color[2]})">${ranking}</div>
    </div>`
}

function getRowHtml(list, colors) {
    let orderedList = orderBy(list, ['Ranking'], ['asc']);
    const nonRanking = [];

    orderedList.forEach(item => {
        if (item.Ranking === 0) {
            nonRanking.push(item);
        }
    });

    if (nonRanking.length) {
        document.body.classList.add('list-has-astrix');

        nonRanking.forEach(item => {
            const index = findIndex(orderedList, o => o.Ziekenhuis === item.Ziekenhuis);

            orderedList.splice(index, 1);
        });
    }

    orderedList = [
        ...orderedList,
        ...nonRanking
    ];

    return reduce(
        orderedList,
        (memo, obj, i) => {
            const color = colors[i];

            return memo += `
                <div class="c-list__row">
                    ${getRanking(obj.Ranking, orderedList, color)}
                    <div class="${classNames.name}">${obj.Ziekenhuis}${renderAstrix(obj.Ranking)}</div>
                    <div class="${classNames.city}">${obj.Plaats}</div>
                    ${getStatus(obj.Positie)}
                    <div class="${classNames.score}">${obj.Rapportcijfer}</div>
                </div>
            `;
        },
        ''
    );
}

function getTemplate() {
    const list = ranking[year],
        colors = interpolateColors(list.length);

    return `
        <div class="${classNames.base}">
            ${getRowHtml(list, colors)}
        </div>
    `
}

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
let isActive = false;

function removeActive() {
    isActive = false;
    publish(markersPlaced);
}

function bindElements(el) {
    const elements = el.querySelectorAll('.c-list__row'),
        array = [].slice.call(elements);

    forEach(reverse(array), element => {
        element.addEventListener('click', () => {
            var index = indexOf(array, element);

            isActive = true;

            publish(rowClicked, { index });
        });
        element.addEventListener('mouseover', () => {
            var index = indexOf(array, element);

            publish(stopMarkersPopup);
            publish(rowHover, { index });
        });
        element.addEventListener('mouseleave', () => {
            if (!isActive) {
                publish(rowOut);
                publish(markersPlaced);
            }
        });
    })
}

function renderList() {
    const template = getTemplate(),
        element = document.querySelector(baseSelector);

    element.innerHTML = template;

    bindElements(element);
}

function changeList({ detail }) {
    const { selectedYear } = detail;

    document.body.classList.remove('list-has-astrix');

    year = selectedYear;

    renderList();
}

function init(baseElement = document.querySelector(baseSelector)) {
    if (!isElement(baseElement)) {
        return false;
    }

    renderList();
};

init();
subscribe(yearSelected, changeList);
subscribe(SIDEBAR_CLOSED, removeActive);